import { useFn } from '@eturi/react'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { pairModalType$, setPairModalType } from '../../reducers/pair.slice'
import { useAppDispatch } from '../../types'
import FullPairModal from './FullPairModal'
import PairDeviceModal from './PairDeviceModal'
import QuickPairModal from './QuickPairModal'

const PairingModal = () => {
	const d = useAppDispatch()
	const activePairModal = useSelector(pairModalType$)

	const handleModalClose = useFn(() => d(setPairModalType(null)))

	switch (activePairModal) {
		case 'pairing_options':
			return <PairDeviceModal onClose={handleModalClose} />

		case 'quick_pair':
			return <QuickPairModal onClose={handleModalClose} />

		case 'full_pair':
			return <FullPairModal onClose={handleModalClose} />

		default:
			return null
	}
}

export default /*@__PURE__*/ memo(PairingModal)
